var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#c81e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    d: "M18.071,8.565,17.007,7.5l-4.221,4.221L8.565,7.5,7.5,8.565l4.221,4.221L7.5,17.007l1.065,1.065,4.221-4.221,4.221,4.221,1.065-1.065L13.85,12.786Z",
    transform: "translate(306.214 248.214)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.917312137696a3a4dcde3c93cb3ef455.svg";
export { ForwardRef as ReactComponent };